import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../constants/theme";
import { INSTAGRAM_URL } from "../utils/whatsapp";
import { useLanguage } from "../i18n/LanguageContext";

const Footer2 = () => {
  let update = new Date();
  const { t } = useLanguage();
  return (
    <>
      <footer className="site-footer style-1 footer-action bg-dark">
        <div className="footer-top">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-md-12">
                <div className="widget widget_about">
                  <div className="footer-logo  logo-white">
                    <Link to={"/"}>
                      <img
                        className="select_logo_white hpa-footer-logo"
                        src={IMAGES.logoWhite}
                        alt="Hybrid Performance Academy"
                      />
                    </Link>
                  </div>
                  <h6 className="m-b15">{t("Our Socials")}</h6>
                  <div className="dz-social-icon style-1">
                    <ul>
                      <li>
                        <a target="_blank" href={INSTAGRAM_URL} rel="noreferrer" aria-label="Instagram">
                          <i className="fab fa-instagram"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-xl-6 col-md-12 wow fadeInUp">
                <div className="widget widget_locations">
                  <h4 className="footer-title">{t("Online Platform")}</h4>
                  <div className="clearfix">
                    <h6>{t("Train Anywhere")}</h6>
                    <p>{t("Access Hybrid Performance Academy from home, the gym, or wherever you train.")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Footer Bottom Part --> */}
        <div className="container">
          <div className="footer-bottom">
            <div className="text-center">
              <span className="copyright-text">
                {t("Copyright © {year}. All rights reserved.", { year: update.getFullYear() })}
              </span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer2;
